import React from "react";
import Spinner from "../components/Spinner";

const GetAToken = () => {
  return <Spinner />;
};

export default GetAToken;
